import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import IoBStackAPIFeatures from "./IoBStackAPIFeatures";
import IoBStackAPIBenefits from "./IoBStackAPIBenefits";

import CTA from "../CTA/CTA";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";

const data1 = [
  "Farming Domain: The farming domain involves managing assets (e.g., tractors, livestock), sites (farms), orders, work orders, and devices (e.g., weather sensors). Events track asset health, site operations, order progress, and environmental data to optimize farming activities and ensure compliance.",
  "Manufacturing Domain: In the manufacturing domain, assets (e.g., machinery), sites (factories), orders, work orders, and products are monitored. Events focus on equipment maintenance, production quality, task progress, and product traceability throughout the manufacturing process.",
  "IOB Proxy: IOB Proxy interacting with various systems such as Gen Doc, Trade Hub, and a Broker to manage report updates and requests. It handles requests from users like operators, qa and managers, validates them through IAM, and integrates with external services to store and retrieve data, ensuring smooth report generation and delivery.",
];
const data2 = [
  "IAM: IAM  validates access tokens, ensuring secure and authorized access to resources and services within the system based on defined policies and permissions.",
  "DB: The database (db) stores configurations, device metadata, topics, and commands, serving as a central repository for managing crucial system information and facilitating efficient data retrieval and manipulation.",

  "IoB Data Pipe Line: The IoB Data Pipeline stores live IoB assets and site data, orders and work orders in a database, then broadcasts it to a Socket.IO server for real-time access and analysis.",
];
export default function IoBStackAPI() {
  return (
    <>
      {/* Display IoB Stack title and description */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle="IoB Stack"
        bannerbodycopy="Connect | Record | Analyze Behaviour"
      />

      {/* Provide an overview of the IoB Stack ecosystem */}
      <SolutionEcosystem title="Overview" type="IoBS" />

      {/* Display key features */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Feature details */}
      <IoBStackAPIFeatures />

      {/* Benefits of IoB Stack integration */}
      <IoBStackAPIBenefits />

      {/* Call-to-Action Section */}
      <Container className="subSectionWrapper">
        <CTA
          btnText="View APIs"
          href="/ComingSoon"
          heading="Do you want to develop applications or integrate your legacy hardware and software?"
        />
      </Container>
    </>
  );
}

